import React from "react";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";

const WelcomeBanner = ({
  userName = "Student",
  onQuickApply,
  quickApplyLabel = "Quick Apply Now",
}) => {
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good Morning";
    if (hour < 17) return "Good Afternoon";
    return "Good Evening";
  };

  const bannerVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  };

  return (
    <motion.div
      variants={bannerVariants}
      initial="hidden"
      animate="visible"
      className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-primary-700 to-primary-800 p-6 sm:p-8 mb-8 shadow-xl"
    >
      <div className="relative z-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
        {/* Greeting */}
        <div className="flex-1">
          <p className="text-white/80 text-sm font-medium">{getGreeting()}!</p>
          <h1 className="text-2xl sm:text-3xl font-bold text-white">
            Welcome back, <span className="text-primary-200">{userName}</span>
          </h1>
        </div>

        {/* Quick Apply Button */}
        {onQuickApply && (
          <div className="flex-shrink-0">
            <button
              onClick={onQuickApply}
              className="
                relative inline-flex items-center gap-2
                px-6 py-3 rounded-xl
                bg-white text-primary-700 font-bold text-sm
                shadow-lg hover:shadow-xl
                hover:bg-primary-50
                transition-all duration-200
                animate-pulse-glow
              "
            >
              {quickApplyLabel}
              <FaArrowRight className="text-xs" />
            </button>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default WelcomeBanner;
